import React, { useState } from 'react';
import { Card, Form, Row, Col, Input, Button, Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getCustomerInquiryReport } from './GeneralService';
import { errHandler } from '../../helper/helper';
import '../../Layout/cardStyle.css';

const CustomerInquirySummary = ({
    loginPlaceId,
    branchId,
}) => {
    const [loading, setLoading] = useState(false);
    const [nic, setNic] = useState('');
    const navigate = useNavigate();

    const handleNicChange = (e) => {
        setNic(e.target.value);
    };

    const handleViewSummary = async () => {
        const trimmedNic = (nic || '').trim();
        if (!trimmedNic) {
            message.warning('Please enter a NIC number.');
            return;
        }

        setLoading(true);

        try {
            const payload = {
                nic: trimmedNic,
            };

            const response = await getCustomerInquiryReport(payload);

            let customerData = null;
            if (response && (response.customer || response.accounts || response.loans)) {
                customerData = response;
            } else if (response && response.data) {
                customerData = response.data;
            }

            if (response && response.status && response.status !== 200) {
                message.error(response.message || 'No customer found for the provided NIC number.');
                return;
            }

            if (!customerData || !customerData.customer) {
                message.error('No customer found for the provided NIC number.');
                return;
            }

            message.success(`Customer details loaded for ${customerData.customer.name || trimmedNic}`);

            // Navigate to detail page
            navigate('/master/reports/general/customer-inquiry-summary', {
                state: {
                    customerData,
                    nic: trimmedNic,
                    reportTitle: `Customer Inquiry Summary - ${trimmedNic}`,
                    loginPlaceId,
                    branchId,
                },
            });
        } catch (err) {
            console.error('Error fetching customer inquiry summary:', err);
            if (err === 'access denied' || err?.status === 401 || err?.status === 403) {
                message.error('Access denied. You do not have permission to view customer inquiry.');
            } else if (err?.data?.message) {
                message.error(err.data.message);
            } else {
                errHandler(err);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={16} lg={12}>
                            <Form.Item
                                label="NIC Number"
                                required
                            >
                                <Input
                                    size="large"
                                    value={nic}
                                    onChange={handleNicChange}
                                    placeholder="Enter NIC Number (e.g. 900902255V or 199009022550)"
                                    allowClear
                                    onPressEnter={handleViewSummary}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    type="primary"
                                    onClick={handleViewSummary}
                                    disabled={loading || !nic.trim()}
                                    className="generate-btn"
                                    size="large"
                                    block
                                >
                                    {loading ? <Spin /> : 'View Details'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default CustomerInquirySummary;
